import axios from 'axios/dist/axios';
import router from '../../../common/router/router';
import Bowser from "bowser";

const defaultState = {
    patientProfileData: {},
    startQuestionsData: [],
    generalQuestionsData: [],
    mustShowFullQuestion: '',
    assessmentToken: '',
    assessmentVersion: '',
    msitat: '',

    footerBtnNext: {
        isEnabled: false
    },
    patientProfileStatus: true,
    questionPriorityList:[],
    shortAnswersPreview:[],
    generalQuestionsAreNotAllAnswered: true,
    generalQuestionsPriorityAreNotAllAnswered: true,
    generalQuestionAreNotAllAnsweredPopup: false,
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    patientProfileData: defaultState.patientProfileData,
    startQuestionsData: defaultState.startQuestionsData,
    generalQuestionsData: defaultState.generalQuestionsData,
    mustShowFullQuestion: defaultState.mustShowFullQuestion,
    assessmentToken: defaultState.assessmentToken,
    assessmentVersion: defaultState.assessmentVersion,
    msitat: defaultState.msitat,

    footerBtnNext: {
        isEnabled: defaultState.footerBtnNext.isEnabled
    },
    patientProfileStatus: defaultState.patientProfileStatus,
    mustShowAssessmentList: defaultState.mustShowAssessmentList,
    questionPriorityList: defaultState.questionPriorityList,
    shortAnswersPreview: defaultState.shortAnswersPreview,
    generalQuestionsAreNotAllAnswered: defaultState.generalQuestionsAreNotAllAnswered,
    generalQuestionsPriorityAreNotAllAnswered: defaultState.generalQuestionsPriorityAreNotAllAnswered,
    generalQuestionAreNotAllAnsweredPopup: defaultState.generalQuestionAreNotAllAnsweredPopup,
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getPatientProfileData: state => state.patientProfileData,

    getStartQuestionsData: state => state.startQuestionsData,
    getStartQuestionsAnswerList (state) {

        if (typeof state.startQuestionsData.questions === "undefined") {
            return [];
        }

        let answeredStartQuestions = state.startQuestionsData.questions.filter((startQuestion) => {
            return (startQuestion.providedAnswer !== null) ? true : false;
        });

        let startQuestionsAnswers = answeredStartQuestions.map((question) => {
            let providedAnswerCode = question.providedAnswer;
            let providedAnswerObj = question.answers.filter((crtAnswer) => {
                return (crtAnswer.code === providedAnswerCode) ? true : false;
            })[0];

             return providedAnswerObj.text;
        });

        return startQuestionsAnswers;
    },

    getGeneralQuestionsData: state => state.generalQuestionsData,
    getMustShowFullQuestion: state => state.mustShowFullQuestion,
    getAssessmentToken: state => state.assessmentToken,
    getAssessmentVersion: state => state.assessmentVersion,
    getMsitat: state => state.msitat,

    getStartQuestionList (state) {
        return (typeof state.startQuestionsData.questions !== 'undefined')
                ? state.startQuestionsData.questions
                : [];
    },

    getGeneralQuestionList (state) {
        return (typeof state.generalQuestionsData.questions !== 'undefined')
                ? state.generalQuestionsData.questions
                : [];
    },

    getIsFooterNextBtnEnabled (state) {
        return (state.footerBtnNext.isEnabled) ? true : false;
    },
    getStartQuestion (state) {
        return (typeof state.startQuestionsData !== 'undefined')
            ? state.startQuestionsData
            : [];
    },

    getGeneralQuestion (state) {
        return (typeof state.generalQuestionsData !== 'undefined')
            ? state.generalQuestionsData
            : [];
    },
    getPatientProfileStatus: state => state.patientProfileStatus,
    getQuestionPriorityList (state) {
        return (typeof state.questionPriorityList !== 'undefined')
            ? state.questionPriorityList
            : [];
    },
    getPriorityStartQuestionsAnswerList (state) {

        if (typeof state.shortAnswersPreview &&
            typeof state.shortAnswersPreview.answers === "undefined") {
            return [];
        } else {
            let answeredPriorityQuestions = state.shortAnswersPreview.answers;

            return answeredPriorityQuestions;
        }
    },
    getGeneralQuestionsAreNotAllAnswered: state => state.generalQuestionsAreNotAllAnswered,
    getGeneralQuestionsPriorityAreNotAllAnswered: state => state.generalQuestionsPriorityAreNotAllAnswered,
    getGeneralQuestionAreNotAllAnsweredPopup: state => state.generalQuestionAreNotAllAnsweredPopup,
};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadAssessmentStartData ({ dispatch, commit, rootGetters, getters }) {
        let promise = new Promise((resolve, reject) => {

            let productCode = rootGetters['ProductListStore/getSelectedProductCode'];
            let requestParams = {};
            if (productCode !== null) {
                requestParams = {
                    productCode: productCode
                };
            }

            // Set assessmentData fields
            let assessmentData = {};

            const assessmentToken = rootGetters['SubmittedValuesStore/getAssessmentToken'];
            if (assessmentToken != null){
                assessmentData.assessmentToken = assessmentToken;
            }

            const msitat = rootGetters['SubmittedValuesStore/getMsitat'];
            if (msitat != null){
                assessmentData.msitat = msitat;
            }

            // get the patientId if there is any
            const pid = rootGetters['SubmittedValuesStore/getPid'];
            if (pid != null) {
                assessmentData.pid = pid;
            }

            if (Object.keys(assessmentData).length > 0) {
                requestParams.assessmentData = assessmentData;
            }

            // Set medData fields
            let medData = {};

            // get the date of birth if one was sent by the auto-login mechanism
            const dob = rootGetters['SubmittedValuesStore/getDob'];
            if (dob != null) {
                medData.birthdate = dob;
            }

            const pregnancy = rootGetters['SubmittedValuesStore/getPregnancy'];
            if (pregnancy != null) {
                medData.pregnancy = pregnancy;
            }

            const weekOfPregnancy = rootGetters['SubmittedValuesStore/getWeekOfPregnancy'];
            if (weekOfPregnancy != null) {
                medData.wop = weekOfPregnancy;
            }

            const weekOfChildbed = rootGetters['SubmittedValuesStore/getWeekOfChildbed'];
            if (weekOfChildbed != null) {
                medData.woc = weekOfChildbed;
            }

            const emergency = rootGetters['SubmittedValuesStore/getEmergency'];
            if (emergency != null) {
                medData.emergency = emergency;
            }

            const fetalMovements = rootGetters['SubmittedValuesStore/getFetalMovements'];
            if (fetalMovements != null) {
                medData.fetmov = fetalMovements;
            }

            const showVitalParams = rootGetters['SubmittedValuesStore/getShowVitalParams'];
            if (showVitalParams != null) {
                medData.vitparam = showVitalParams;
            }

            const heartFrequency = rootGetters['SubmittedValuesStore/getHeartFrequency'];
            if (heartFrequency != null) {
                medData.heartrate = heartFrequency;
            }

            const breathFrequency = rootGetters['SubmittedValuesStore/getBreathFrequency'];
            if (breathFrequency != null) {
                medData.brrate = breathFrequency;
            }

            const oxygeneLevel = rootGetters['SubmittedValuesStore/getOxygeneLevel'];
            if (oxygeneLevel != null) {
                medData.oxsat = oxygeneLevel;
            }

            const upperBloodPressure = rootGetters['SubmittedValuesStore/getUpperBloodPressure'];
            if (upperBloodPressure != null) {
                medData.systbp = upperBloodPressure;
            }

            const lowerBloodPressure = rootGetters['SubmittedValuesStore/getLowerBloodPressure'];
            if (lowerBloodPressure != null) {
                medData.diastbp = lowerBloodPressure;
            }

            const bodyTemperature = rootGetters['SubmittedValuesStore/getBodyTemperature'];
            if (bodyTemperature != null) {
                medData.btemp = bodyTemperature;
            }

            const bloodSugarMoll = rootGetters['SubmittedValuesStore/getBloodSugarMoll'];
            if (bloodSugarMoll != null) {
                medData.blsugmmoll = bloodSugarMoll;
            }

            const bloodSugarMgdl = rootGetters['SubmittedValuesStore/getBloodSugarMgdl'];
            if (bloodSugarMgdl != null) {
                medData.blsugmgdl = bloodSugarMgdl;
            }

            const breathing = rootGetters['SubmittedValuesStore/getBreathing'];
            if (breathing != null) {
                medData.breathing = breathing;
            }

            const heartCirculation = rootGetters['SubmittedValuesStore/getHeartCirculation'];
            if (heartCirculation != null) {
                medData.hrtcirc = heartCirculation;
            }

            const neurologicalMentalState = rootGetters['SubmittedValuesStore/getNeurologicalMentalState'];
            if (neurologicalMentalState != null) {
                medData.neuroment = neurologicalMentalState;
            }

            const abdomen = rootGetters['SubmittedValuesStore/getAbdomen'];
            if (abdomen != null) {
                medData.abdomen = abdomen;
            }

            const trauma = rootGetters['SubmittedValuesStore/getTrauma'];
            if (trauma != null) {
                medData.trauma = trauma;
            }

            const other = rootGetters['SubmittedValuesStore/getOther'];
            if (other != null) {
                medData.other = other;
            }

            const emergind = rootGetters['SubmittedValuesStore/getEmergind'];
            if (emergind != null) {
                medData.emergind = emergind;
            }

            let sex = rootGetters['SubmittedValuesStore/getSex'];
            if (sex !== null){
                if (sex === 'm'){
                    sex = "male";
                }
                if (sex === 'f'){
                    sex = "female";
                }
            }

            if (sex != null) {
                medData.sex = sex;
            }

            if (Object.keys(medData).length > 0) {
                requestParams.medData = medData;
            }

            // Set parameters fields
            let parameters = {};

            let showAssessment = rootGetters['SymptomsQuestionsStore/getMustShowAssessmentList'];
            let priorityList = showAssessment;
            if (priorityList != null) {
                parameters.priorityList = priorityList;
            }

            parameters.theme = rootGetters['ThemeStore/getTheme'];

            const browser = Bowser.getParser(window.navigator.userAgent);

            parameters.browserName = browser.getBrowserName();
            parameters.browserVersion = browser.getBrowserVersion();
            parameters.browserOS = browser.getOSName() + " " + browser.getOSVersion();

            let dc = rootGetters['SubmittedValuesStore/getDc'];
            if (dc != null) {
                parameters.dc = dc;
            }

            requestParams.parameters = parameters;

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/startAssessment', requestParams);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    dispatch("updateAssessmentStartData", response.data);

                    if (typeof response.data.data !== "undefined" && typeof response.data.data.APP_PROPERTIES !== "undefined" && typeof response.data.data.APP_PROPERTIES.appProperties !== "undefined") {
                        commit("TranslationStore/setAppProperties", response.data.data.APP_PROPERTIES.appProperties, {root: true});
                        dispatch("SymptomsQuestionsStore/updateAssessmentTypeByAppProp", null, {root: true});
                    }

                    resolve(response);
                } else {
                    reject(response);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });

        });

        return promise;
    },

    loadAssessmentTestData ({ dispatch, rootGetters }) {
        let promise = new Promise((resolve, reject) => {

            let productCode = rootGetters['ProductListStore/getSelectedProductCode'];
            let requestParams = {};
            if (productCode !== null) {
                requestParams = {
                    productCode: productCode
                };
            }

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/createTestAssessment', requestParams);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    dispatch("updateAssessmentStartData", response.data);

                    resolve(response);
                } else {
                    reject(response);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    updateAssessmentStartData ({commit, dispatch}, axiosResponseData) {
        commit("clearPatientProfileData");
        commit("clearGeneralQuestionsData");
        commit("clearStartQuestionsData");
        if (typeof axiosResponseData.data !== "undefined") {

            if (typeof axiosResponseData.data.PRODUCT_TEXTS !== "undefined" && typeof axiosResponseData.data.PRODUCT_TEXTS.productTextMap !== "undefined") {
                dispatch('TranslationStore/appendProductRelatedTranslationData', axiosResponseData.data.PRODUCT_TEXTS.productTextMap, { root: true });
            }

            if (typeof axiosResponseData.data.PATIENT_DATA !== "undefined") {
                commit('setPatientProfileData', axiosResponseData.data.PATIENT_DATA);
            }
            if (typeof axiosResponseData.data.VITAL_PARAMETERS !== "undefined") {
                dispatch('VitalParametersStore/setupVitalParameters', axiosResponseData.data.VITAL_PARAMETERS, {root: true});
            }
            if (typeof axiosResponseData.data.START_QUESTIONS !== "undefined") {
                commit('setStartQuestionsData', axiosResponseData.data.START_QUESTIONS);
            }
            if (typeof axiosResponseData.data.GENERAL_QUESTIONS !== "undefined") {
                commit('setGeneralQuestionsData', axiosResponseData.data.GENERAL_QUESTIONS);
            }
            if (typeof axiosResponseData.data.START_ASSESSMENT_PRIORITY !== "undefined") {
                commit('setQuestionPriorityList', axiosResponseData.data.START_ASSESSMENT_PRIORITY);
            }
            if (typeof axiosResponseData.data.SHORT_ANSWERS_PREVIEW !== "undefined") {
                commit('setShortAnswersPreview', axiosResponseData.data.SHORT_ANSWERS_PREVIEW);
            }
            if (typeof axiosResponseData.assessment !== "undefined") {
                commit('setAssessmentToken', axiosResponseData.assessment.assessmentToken);
            }

            if (typeof axiosResponseData.data.START_QUESTIONS !== "undefined"
                && typeof axiosResponseData.data.START_QUESTIONS.countAnswered !== "undefined"
                && typeof axiosResponseData.data.START_QUESTIONS.countTotal !== "undefined"
                && axiosResponseData.data.START_QUESTIONS.countAnswered === axiosResponseData.data.START_QUESTIONS.countTotal) {
                commit("enableFooterBtnNext");
            }
            else if(typeof axiosResponseData.data.START_ASSESSMENT_PRIORITY !== "undefined"
            ) {
                let startQuestions = [];
                let startQuestionsAnswered = [];
                let generalQuestions = [];
                let generalQuestionsAnswered = [];
                for(let i= 0; i < axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions.length; i++) {
                    if(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].type === 'START') {
                        startQuestions.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                        if(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].providedAnswer) {
                            startQuestionsAnswered.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                            if(startQuestions.length === startQuestionsAnswered.length) {
                                commit("enableFooterBtnNext");
                            }
                            else {
                                commit("disableFooterBtnNext");
                            }
                        }
                    }
                    else if(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].type === 'GENERAL') {
                        generalQuestions.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                        if(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].providedAnswer) {
                            generalQuestionsAnswered.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                            if(generalQuestions.length === generalQuestionsAnswered.length) {
                                state.generalQuestionsPriorityAreNotAllAnswered = false;
                            }
                            else {
                                state.generalQuestionsPriorityAreNotAllAnswered = true;
                            }
                        }

                    }
                }
            }
            else {
                commit("disableFooterBtnNext");
            }

            if (typeof axiosResponseData.data.GENERAL_QUESTIONS !== "undefined"
                && typeof axiosResponseData.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                && typeof axiosResponseData.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                && axiosResponseData.data.GENERAL_QUESTIONS.countAnswered === axiosResponseData.data.GENERAL_QUESTIONS.countTotal) {
                state.generalQuestionsAreNotAllAnswered= false;
            }
            else{
                state.generalQuestionsAreNotAllAnswered= true;
            }

            dispatch("AssessmentAlertsStore/refreshAlerts", axiosResponseData, { root: true });
        }

        commit("ProductListStore/clearSelectedProductCode", {}, {root: true});
    },

    updateAssessmentStartQuestionsData ({commit, dispatch}, axiosResponseData) {
        commit("clearStartQuestionsData");
        commit("clearGeneralQuestionsData");

        if (typeof axiosResponseData.data !== "undefined") {

            if (typeof axiosResponseData.data.START_QUESTIONS !== "undefined") {
                commit('setStartQuestionsData', axiosResponseData.data.START_QUESTIONS);
            }
            if (typeof axiosResponseData.data.GENERAL_QUESTIONS !== "undefined") {
                commit('setGeneralQuestionsData', axiosResponseData.data.GENERAL_QUESTIONS);
            }

            if (typeof axiosResponseData.data.START_ASSESSMENT_PRIORITY !== "undefined") {
                commit('setQuestionPriorityList', axiosResponseData.data.START_ASSESSMENT_PRIORITY);
            }

            if (typeof axiosResponseData.data.SHORT_ANSWERS_PREVIEW !== "undefined") {
                commit('setShortAnswersPreview', axiosResponseData.data.SHORT_ANSWERS_PREVIEW);
            }

            if (typeof axiosResponseData.assessment !== "undefined") {
                commit('setAssessmentToken', axiosResponseData.assessment.assessmentToken);
            }

            if (typeof axiosResponseData.data.VITAL_PARAMETERS !== "undefined") {
                dispatch('VitalParametersStore/setupVitalParameters', axiosResponseData.data.VITAL_PARAMETERS, {root: true});
            }

            let areAllStartQuestionsAnswered = (typeof axiosResponseData.data.START_QUESTIONS !== "undefined"
                    && typeof axiosResponseData.data.START_QUESTIONS.countAnswered !== "undefined"
                    && typeof axiosResponseData.data.START_QUESTIONS.countTotal !== "undefined"
                    && axiosResponseData.data.START_QUESTIONS.countAnswered === axiosResponseData.data.START_QUESTIONS.countTotal) ? true : false;
            let areAllGeneralQuestionsAnswered = (typeof axiosResponseData.data.GENERAL_QUESTIONS !== "undefined"
                    && typeof axiosResponseData.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                    && typeof axiosResponseData.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                    && axiosResponseData.data.GENERAL_QUESTIONS.countAnswered === axiosResponseData.data.GENERAL_QUESTIONS.countTotal) ? true : false;

            if (areAllStartQuestionsAnswered) {
                commit("enableFooterBtnNext");
                if(areAllGeneralQuestionsAnswered) {
                    state.generalQuestionsAreNotAllAnswered= false;
                }
            }
            else if(typeof axiosResponseData.data.START_ASSESSMENT_PRIORITY !== "undefined"
            ) {
                let startQuestions = [];
                let startQuestionsAnswered = [];
                let generalQuestions = [];
                let generalQuestionsAnswered = [];
                for(let i= 0; i < axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions.length; i++) {
                    if (axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].type === 'START') {
                        startQuestions.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                        if (axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].providedAnswer) {
                            startQuestionsAnswered.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                            if (startQuestions.length === startQuestionsAnswered.length) {
                                commit("enableFooterBtnNext");
                            } else {
                                commit("disableFooterBtnNext");
                            }
                        }
                    } else if (axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].type === 'GENERAL') {

                        generalQuestions.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                        if (axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].providedAnswer) {
                            generalQuestionsAnswered.push(axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i]);
                        }
                        // SMASSDEV - 1066.
                        // The if from line 432 is not working if the providedAnswer is null on the response data
                        // We need to check if all general questions are answered when we receive the data from /provideAnswer even if the providedAnswer is null on the response
                        // If we check only when the providedAnswer is not null, when we call /provideAnswer when we remove the answer to a pre-triage question
                        // the NotAllGenQuestionsAnswered popup is not going to be shown.
                        // The problem is on products with only one general question, when we remove the answer to the question.
                        // if we check outside the if (axiosResponseData.data.START_ASSESSMENT_PRIORITY.questions[i].providedAnswer) then we cover the case when the providedAnswer is null
                        if (generalQuestions.length === generalQuestionsAnswered.length) {
                            state.generalQuestionsPriorityAreNotAllAnswered= false;

                        } else {
                            state.generalQuestionsPriorityAreNotAllAnswered = true;
                        }

                    }
                }
            }
            else {
                commit("disableFooterBtnNext");
            }

            if(areAllGeneralQuestionsAnswered) {
                state.generalQuestionsAreNotAllAnswered = false;
            }
            else {
                state.generalQuestionsAreNotAllAnswered = true;
            }

            dispatch("AssessmentAlertsStore/refreshAlerts", axiosResponseData, { root: true });
        }
    },


    loadGeneralQuestionList ({ commit }) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/generalQuestions');
            axiosRequest.then((response) => {

                commit('setGeneralQuestionsData', response.data.data.GENERAL_QUESTIONS);

                if (typeof response.data.data !== "undefined"
                        && typeof response.data.data.GENERAL_QUESTIONS !== "undefined"
                        && typeof response.data.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                        && typeof response.data.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                        && response.data.data.GENERAL_QUESTIONS.countAnswered === response.data.data.GENERAL_QUESTIONS.countTotal) {
                    state.generalQuestionsAreNotAllAnswered = false;
                }
                else {
                    state.generalQuestionsAreNotAllAnswered = true;
                }

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitPatientPid ({getters}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/patientData', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save patient profile.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitPatientComment ({getters}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/patientData', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save patient profile.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },
    submitPatientProfileComment ({getters}, data) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/patientData', data);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save patient profile comment.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitPersistPatientProfileComment ({getters}) {
        let promise = new Promise((resolve, reject) => {
            let patientProfileData = getters.getPatientProfileData;

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/persistPatientComment', {
                fieldName: "COMMENT",
                fieldValue: ((patientProfileData.comment) ? patientProfileData.comment : "")
            });
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    resolve(response);
                } else {
                    reject("Couldn't save patient profile comment.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },


    submitStartQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideAnswer', {
                questionCode: data.questionCode,
                answerCode: data.newProvidedAnswerCode
            });
            axiosRequest.then((response) => {

                dispatch("updateAssessmentStartQuestionsData", response.data);
                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitGeneralQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideAnswer', {
                questionCode: data.questionCode,
                answerCode: data.newProvidedAnswerCode
            });
            axiosRequest.then((response) => {

                dispatch("updateAssessmentStartQuestionsData", response.data);
                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },


    submitSpecificQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideAnswer', {
                questionCode: data.questionCode,
                answerCode: data.newProvidedAnswerCode
            });
            axiosRequest.then((response) => {

                dispatch("updateAssessmentStartQuestionsData", response.data);
                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    confirmNotAllGenQAreAnswered({commit, dispatch}) {
        let requestParams = {
            value: state.generalQuestionsAreNotAllAnswered
        }
        let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/incompletePretriage', requestParams);

        axiosRequest.then(() => {
            router.push('/main-symptom');
        })
    }

};



// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setStartQuestionsData (state, startQuestions) {
        state.startQuestionsData = startQuestions;
    },

    clearStartQuestionsData (state) {
        state.startQuestionsData = new Array();
    },

    setGeneralQuestionsData (state, generalQuestions) {
        state.generalQuestionsData = generalQuestions;
    },

    clearGeneralQuestionsData (state) {
        state.generalQuestionsData = [];
    },

    setPatientProfileData (state, newDataObj) {
        state.patientProfileData = newDataObj;
    },
    setPatientProfileComment (state, newVal) {
        state.patientProfileData.comment = newVal;
    },
    clearPatientProfileData (state) {
        state.patientProfileData = {};
    },
    clearPatientProfileComment (state) {
        state.patientProfileData.comment = "";
    },

    setMustShowFullQuestion (state, newVal) {
        state.mustShowFullQuestion = newVal;
    },

    setAssessmentToken (state, newValue) {
        sessionStorage.setItem('proAssessmentToken', newValue);
        state.assessmentToken = newValue;
    },
    clearAssessmentToken (state) {
        sessionStorage.removetItem('proAssessmentToken'); // @TODO "removet"?? "removeT"?? This can't be working!
        state.assessmentToken = defaultState.assessmentToken;
    },
    setAssessmentVersion (state, newValue) {
        sessionStorage.setItem('proAssessmentVersion', newValue);
        state.assessmentVersion = newValue;
    },
    clearAssessmentVersion (state) {
        sessionStorage.removetItem('proAssessmentVersion'); // @TODO "removet"?? "removeT"?? This can't be working!
        state.assessmentVersion = defaultState.assessmentVersion;
    },

    setMsitat (state, newVal) {
        state.msitat = newVal;
    },
    clearMsitat (state) {
        state.msitat = "";
    },


    /**
     * Set answer id on a Start Question.
     * @param {Object} state
     * @param {Object} data - Expected properties: "questionCode", "answerCode"
     * @return {Void}
     */
    setStartQuestionAnswer (state, data) {
        let startQuestionIndex = state.startQuestionsData.questions.findIndex((startQuestion) => {
            return startQuestion.code == data.questionCode;
        });

        if (startQuestionIndex !== -1) {
            state.startQuestionsData.questions[startQuestionIndex].providedAnswer = data.answerCode
        }
    },

    enableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = true;
    },
    disableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = false;
    },

    setPatientProfileStatus (state, newVal) {
        state.patientProfileStatus = newVal;
    },
    setQuestionPriorityList (state, questionPriorityList) {
        state.questionPriorityList = questionPriorityList;
    },

    setShortAnswersPreview(state, newVal) {
        state.shortAnswersPreview = newVal;
    },

    setGeneralQuestionsAreNotAllAnswered(state, newVal) {
        state.generalQuestionsAreNoAllAnswered = newVal;
    },

    setGeneralQuestionsPriorityAreNotAllAnswered(state, newVal) {
       state.generalQuestionsPriorityAreNotAllAnswered = newVal;
    },

    setGeneralQuestionAreNotAllAnsweredPopup(state, newVal){
        state.generalQuestionAreNotAllAnsweredPopup = newVal;
    },


    // ----------------------------------------------------------

    resetStore (state) {
        state.patientProfileData    = defaultState.patientProfileData;
        state.startQuestionsData    = defaultState.startQuestionsData;
        state.generalQuestionsData  = defaultState.generalQuestionsData;
        state.mustShowFullQuestion  = defaultState.mustShowFullQuestion;
        state.assessmentToken       = defaultState.assessmentToken;
        state.assessmentVersion     = defaultState.assessmentVersion;
        state.msitat                = defaultState.msitat;
        state.footerBtnNext = {
            isEnabled: defaultState.footerBtnNext.isEnabled
        };
        state.patientProfileStatus  = defaultState.patientProfileStatus;
        state.shortAnswersPreview = defaultState.shortAnswersPreview;
        state.generalQuestionsAreNotAllAnswered = defaultState.generalQuestionsAreNotAllAnswered;
        state.generalQuestionAreNotAllAnsweredPopup = defaultState.generalQuestionAreNotAllAnsweredPopup;
        state.generalQuestionsPriorityAreNotAllAnswered = defaultState.generalQuestionsPriorityAreNotAllAnswered;

        // SMASSDEV - 1048. questionPriorityList was not reset in the resetStore
        state.questionPriorityList  = defaultState.questionPriorityList;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/AssessmentStartStore.js